<template>
    <div class="wlx-adopt-school">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">站点管理</span>
            </div>
            <div class="fr btn-right">
                 <el-form :inline="true" size="small">
                    <div class="dd-search-form-news">
                        <el-form-item>
                            <el-input v-model="schoolTitle" placeholder="请输入站点名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="siteType" clearable placeholder="请选择站点类型">
                                <el-option label="培训站点" value="1"></el-option>
                                <el-option label="考核站点" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="isKZ" clearable placeholder="是否是扩招站点">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <a class="export-button-a" style="color:#fff" :href="exportExcelStu" v-if="userInfo.isSys">导出</a>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="yk-wrap-fixeds clearfix">
            <div class="ad-school-manager-head fr">
            </div>
            <!-- 新增/修改站点 -->
            <el-dialog :title="tisi" v-if="addNewNoticeVisible" :visible.sync="addNewNoticeVisible" :before-close="cancel" :append-to-body="true" width="70%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="160px">
                        <el-form-item label="站点名称" prop="title">
                            <el-input v-model="SchoolName"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" style="80px">
                            <el-select v-model="SchoolType" clearable placeholder="请选择类型">
                                <el-option label="中职" value="中职"></el-option>
                                <el-option label="高职" value="高职"></el-option>
                                <el-option label="本科" value="本科"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省市">
                            <el-select v-model="SchoolProvince" clearable placeholder="请选择省份" @change="getCityList">
                                <el-option v-for="item in ProvinceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-select v-model="SchoolCity" clearable placeholder="请选择城市">
                                <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地址">
                            <el-input placeholder="请输入地址"
                                v-model="address"
                                clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系人姓名">
                            <el-input v-model="Contacts"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话" v-if="userInfo.isSys">
                            <el-input v-model="ContactsPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="学生数">
                            <el-input-number v-model="StudentCount"></el-input-number>
                        </el-form-item>
                        <el-form-item label="照片">
                             <imageUpload :url="urlAliyunOSS" :files.sync="cover" format="image"></imageUpload>
                        </el-form-item>
                        <el-form-item label="是否为培训站点">
                            <el-radio-group v-model="isLecturer">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否为考核站点">
                            <el-radio-group v-model="isAppraiser">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addNewNoticeVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addOrEditSchool()">确 定</el-button>
                </span>
            </el-dialog>
            <!--导入-->
            <el-dialog :before-close="cancel" title="Excel导入" :visible.sync="ImportDialogVisible" width="50%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
                <p class="excelparaph">注意事项：</p>
                <ul class="attention_excel">
                    <li>写表格时请注意查看填写须知</li>
                </ul>
                <el-form ref="form" label-width="80px" size="mini" @submit.prevent="importFile">
                    <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList" :auto-upload="false" :on-success="onSuccess" accept="xls" :limit="1" style="display: inline-block; margin: 0 44px;">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <el-table :data="errorList" v-show="errorList.length > 0" style="width: 100%">
                        <el-table-column prop="row" label="行号" width="180"></el-table-column>
                        <el-table-column prop="error" label="错误" style="width:80%"></el-table-column>
                    </el-table>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="ImportDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="importFile()">确 定</el-button>
                </div>
            </el-dialog>
            <div>
                <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange">
                    <el-table-column prop="id" type="selection" width="55"></el-table-column>
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column prop="SchoolName" label="站点名称"></el-table-column>
                    <el-table-column prop="SchoolProvince" label="省份"></el-table-column>
                    <el-table-column prop="SchoolCity" label="城市"></el-table-column>
                    <el-table-column prop="SchoolType" label="类型"></el-table-column>
                    <el-table-column prop="StudentCount" label="学生数"></el-table-column>
                    <el-table-column prop="Contacts" label="联系人姓名"></el-table-column>
                    <el-table-column prop="ContactsPhone" label="联系人电话" width="160"></el-table-column>
                    <el-table-column prop="IsLecturer" label="是否是培训站点" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.IsLecturer == 0">不是</span>
                            <span v-if="scope.row.IsLecturer == 1">是</span>
                            <span v-if="scope.row.IsLecturer == 2">审核中</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="IsAppraiser" label="是否是考核站点" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.IsAppraiser == 0">不是</span>
                            <span v-if="scope.row.IsAppraiser == 1">是</span>
                            <span v-if="scope.row.IsAppraiser == 2">审核中</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="IsAppraiser" label="是否是扩招站点" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.IsKZ == 0">不是</span>
                            <span v-if="scope.row.IsKZ == 1">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="查看管理员" placement="top-start">
                                <el-button size="mini" class="el-icon-s-check" @click="goManager(scope.row.Id)" type="primary"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <el-button size="mini" class="el-icon-edit" @click="edit(scope.row)" type="primary" title="编辑"></el-button>
                            </el-tooltip>

                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <el-button size="mini" type="danger" class="el-icon-delete" @click="deleteSchool(scope.row.Id)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="news-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            tisi: "",
            isKZ: "",
            /* -----------添加/修改弹框参数------------ */
            id: "",
            SchoolName: "",
            SchoolProvince: "",
            SchoolCity: "",
            Contacts: "",
            StudentCount: 0,
            ContactsPhone: "",
            SchoolType: "",
            ProvinceList: [],
            cityList: [],
            isLecturer: "",
            isAppraiser: "",
            address:"",
            cover:"",
            /* --------------------------------------- */
            ids: [],
            value: "",
            schoolTitle: "",
            siteType: "",
            schoolProvince: "",
            schoolCity: "",
            // excel导入
            uploadUrl: "/api/XOrg/School/uploadExcel",
            errorList: [],
            fileList: [],
            ImportDialogVisible: false,
            // exportExcelStu:''
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
        };
    },
    components: {
      imageUpload
    },
    created() {
        this.getSessionStorage();
        this.school = this.$store.state.auth.userName;
        this.getSchoolList();
        this.getAllProvinceList();
        // this.exportExcelStu =  "/api/XOrg/School/exportSiteExcel?schoolName="+ this.schoolTitle;
    },
    props:{
        certificateId: {
        type: String,
        default: ""
        }
    },
    computed: {
        exportExcelStu: function() {
            return "/api/XOrg/School/exportSiteExcel?schoolName=" + this.schoolTitle + "&siteType=" + this.siteType+"&certificateId="+this.certificateId;
        },
        userInfo() {
            return this.$store.state.auth;
        },
    },
    methods: {
        handleCommand(command) {
            if (command.type === "a") {
                //跳转设置讲师页面
                this.$router.push({
                    name: "setUpTeacher",
                    params: {
                        siteId: command.id,
                    },
                });
            } else {
                //跳转设置考评员页面
                this.$router.push({
                    name: "setUpCommentator",
                    params: {
                        siteId: command.id,
                    },
                });
            }
        },

        //获取省
        getAllProvinceList() {
            var that = this;
            this.$http.post("/api/XOrg/School/getAllProvinceList", {}).then((rst) => {
                if (rst.code == 1) {
                    that.ProvinceList = rst.province;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        // 获取市
        getCityList(val) {
            var that = this;
            this.$http
                .post("/api/XOrg/School/getCityList", {
                    province: val,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        that.cityList = rst.cityList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getSchoolList() {
            var that = this;
            this.$http
                .post("/api/XOrg/School/getSchoolList", {
                    schoolName: this.schoolTitle,
                    siteType: this.siteType,
                    schoolProvince: this.schoolProvince,
                    schoolCity: this.schoolCity,
                    certificateId:this.certificateId,
                    isKZ: this.isKZ,
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        that.list = rst.list;
                        that.total = rst.pagination.totalCount;
                        that.pageSize = rst.pagination.pageSize;
                        that.pageIndex = rst.pagination.pageIndex;

                        // 参数存储本地缓存
                        sessionStorage.setItem("wlx_adoptSchool_schoolTitle", that.schoolTitle);
                        sessionStorage.setItem("wlx_adoptSchool_siteType", that.siteType);
                        sessionStorage.setItem("wlx_adoptSchool_schoolProvince", that.schoolProvince);
                        sessionStorage.setItem("wlx_adoptSchool_schoolCity", that.schoolCity);
                        sessionStorage.setItem("wlx_adoptSchool_isKZ", that.isKZ);
                        sessionStorage.setItem("wlx_adoptSchool_pageIndex", that.pageIndex);
                        sessionStorage.setItem("wlx_adoptSchool_pageSize", that.pageSize);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        // 获取网页缓存信息
        getSessionStorage() {
            // 获取网页缓存信息
            var schoolTitle = sessionStorage.getItem("wlx_adoptSchool_schoolTitle");
            var siteType = sessionStorage.getItem("wlx_adoptSchool_siteType");
            var schoolProvince = sessionStorage.getItem("wlx_adoptSchool_schoolProvince");
            var schoolCity = sessionStorage.getItem("wlx_adoptSchool_schoolCity");
            var isKZ = sessionStorage.getItem("wlx_adoptSchool_isKZ");
            var pageIndex = Number(sessionStorage.getItem("wlx_adoptSchool_pageIndex"));
            var pageSize = Number(sessionStorage.getItem("wlx_adoptSchool_pageSize"));

            if (schoolTitle != null && schoolTitle != undefined && schoolTitle != "null" && schoolTitle != "undefined") {
                this.schoolTitle = schoolTitle;
            }
            if (siteType != null && siteType != undefined && siteType != "null" && siteType != "undefined") {
                this.siteType = siteType;
            }
            if (schoolProvince != null && schoolProvince != undefined && schoolProvince != "null" && siteType != "undefined") {
                this.schoolProvince = schoolProvince;
            }
            if (schoolCity != null && schoolCity != undefined && schoolCity != "null" && schoolCity != "undefined") {
                this.schoolCity = schoolCity;
            }
            if (isKZ != null && isKZ != undefined && isKZ != "null" && isKZ != "undefined") {
                this.isKZ = isKZ;
            }
            if (pageIndex != null && pageIndex != undefined) {
                this.pageIndex = pageIndex;
            }
            if (pageSize != null && pageSize != undefined) {
                this.pageSize = pageSize;
            }
        },
        onPageChangeHandler(page) {
            this.pageIndex = page;
            this.getSchoolList();
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this.getSchoolList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.Id);
            });
        },
        addOrEditSchool() {
            var that = this;
            this.$http
                .post("/api/XOrg/School/addOrEditSchool", {
                    id: that.id,
                    schoolName: that.SchoolName,
                    schoolProvince: that.SchoolProvince,
                    schoolCity: that.SchoolCity,
                    studentCount: that.StudentCount,
                    contacts: that.Contacts,
                    contactsPhone: that.ContactsPhone,
                    schoolType: that.SchoolType,
                    isLecturer: that.isLecturer,
                    isAppraiser: that.isAppraiser,
                    address:that.address,
                    cover:that.cover,
                    certificateId: that.certificateId
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.$message.success(rst.msg);
                        that.getSchoolList();
                        that.addNewNoticeVisible = false;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        add() {
            this.tisi = "新增站点";
            this.addNewNoticeVisible = true;
            this.id = "";
            this.SchoolName = "";
            this.SchoolProvince = "";
            this.SchoolCity = "";
            this.StudentCount = "";
            this.Contacts = "";
            this.ContactsPhone = "";
            this.SchoolType = "";
            this.isAppraiser = "";
            this.isLecturer = "";
            this.address = "";
            this.cover = "";
        },
        edit(row) {
            this.tisi = "编辑站点";
            this.addNewNoticeVisible = true;
            this.id = row.Id;
            this.SchoolName = row.SchoolName;
            this.SchoolProvince = row.SchoolProvince;
            this.SchoolCity = row.SchoolCity;
            this.StudentCount = row.StudentCount;
            this.Contacts = row.Contacts;
            this.ContactsPhone = row.ContactsPhone;
            this.SchoolType = row.SchoolType;
            this.isAppraiser = row.IsAppraiser;
            this.isLecturer = row.IsLecturer;
            this.address = row.Address;
            this.cover = row.Cover;
            this.getCityList(row.SchoolProvince);
        },
        cancel() {
            this.addNewNoticeVisible = false;
        },
        deleteSchool(id) {
            this.$confirm("此操作将删除该站点, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var that = this;
                    this.$http
                        .post("/api/XOrg/School/deleteSchool", {
                            ids: id,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message.success(rst.msg);
                                that.getSchoolList();
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        search() {
            this.pageIndex = 1;
            this.getSchoolList();
        },
        deleteAll() {
            if (this.ids.length === 0) {
                this.$message({
                    showClose: true,
                    message: "请选择站点",
                    type: "warning",
                });
                return false;
            }
            this.$confirm("此操作将删除所选站点, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var that = this;
                    this.$http
                        .post("/api/XOrg/School/deleteSchool", {
                            ids: that.ids,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message.success(rst.msg);
                                this.getSchoolList();
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // excel导入
        // 导入
        importFile() {
            this.$refs.upload.submit();
        },
        onSuccess(res) {
            if (res.code < 0) {
                if (res.code === -5) {
                    this.errorList = res.list;
                } else {
                    this.$message.warning(res.msg);
                }
            } else {
                this.$message.success("导入成功");
                this.ImportDialogVisible = false;
                this.fileList = [];
                this.getSchoolList(1);
            }
        },
        // 查看管理员
        goManager(schoolId) {
            this.$router.push({
                name: "adoptSchoolManager",
                params: {
                    schoolId: schoolId,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.wlx-adopt-school {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
